import { getStyle, resolveText, wrapText } from "./studioModel";
import { textWidth } from "./studioMeasure";
// Measurement is shared with the canvas and exports (studioMeasure).
export { textWidth } from "./studioMeasure";
export function fitPriceFrames(doc, content) {
  return { ...doc, pages: doc.pages.map((p) => ({ ...p, elements:p.elements.map((n) => {
    if (n.type !== "text" || n.role !== "price" || n.locked) return n;
    const style = getStyle(doc,n), text = resolveText(n,content);
    const needed = Math.max(...String(text).split("\n").map((t) => textWidth(t,style))) + 3 + (style.letterSpacing || 0);
    const w = Math.min(p.width - p.margin*2, Math.max(n.w,needed));
    const anchor = style.align === "center" ? .5 : style.align === "right" ? 1 : 0;
    const x = Math.max(p.margin,Math.min(p.width-p.margin-w,n.x-(w-n.w)*anchor));
    return { ...n,x,w,h:Math.max(n.h,style.fontSize*style.lineHeight+2) };
  }) })) };
}

// Description frames track their printed lines instead of retaining empty rows.
export function fitDescriptionFrames(doc, content, ids) {
  const selected = ids && new Set(ids);
  return { ...doc, pages: doc.pages.map(page => ({ ...page, elements: page.elements.map(node => {
    if (node.type !== "text" || node.role !== "description" || node.locked || node.rotation || (selected && !selected.has(node.id))) return node;
    const style = getStyle(doc, node);
    const lines = wrapText(resolveText(node, content), style, node.w, text => textWidth(text, style));
    const h = Math.ceil(style.fontSize * 1.3 + Math.max(0, lines.length - 1) * style.fontSize * style.lineHeight);
    return h === node.h ? node : { ...node, h };
  }) })) };
}
